import React, { useState } from "react";
import StyleInput from "../../components/Button/Input";
import PostReq from "../../utils/PostReq";
const ShemshPop = ({ setData, handleClose }) => {
  const [Changes, setChanges] = useState("");
  const handleChange = (property, value) => {
    setChanges((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };
  const AddShemsh = async () => {
    const result = await PostReq({
      method: "Post",
      url: "/xtra/add-shemsh",
      body: { ...Changes },
    });
    setData(result.filter);
    handleClose();
  };
  return (
    <div className="shemsh-modal-box">
      <div className="modal-title">
        <h4 style={{ textAlign: "right" }}>ثبت شمش جدید</h4>
      </div>
      <div className="modal-wrapper">
        <div className="input-wrapper" style={{ width: "50%" }}>
          <StyleInput
            title={"تا"}
            direction={"rtl"}
            action={(e) => handleChange("to", e)}
          />
        </div>
        <div className="input-wrapper" style={{ width: "50%" }}>
          <StyleInput
            title={"از"}
            direction={"rtl"}
            style={{ width: "50%" }}
            action={(e) => handleChange("from", e)}
          />
        </div>

        <div className="input-wrapper">
          <StyleInput
            title={"قیمت"}
            direction={"rtl"}
            action={(e) => handleChange("price", e)}
            style={{ width: "100%" }}
          />
        </div>
      </div>
      <div className="modal-btn-wrapper">
        <button onClick={AddShemsh} style={{ backgroundColor: "lightgreen" }}>
          ثبت
        </button>
        <button
          onClick={handleClose}
          style={{ backgroundColor: "red", color: "white" }}
        >
          انصراف
        </button>
      </div>
    </div>
  );
};

export default ShemshPop;
